/**
 * Created by i.lovenkov on 10.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

require('./RegistrationView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RegistrationView: {
        displayName: 'RegistrationView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Registration/default/RegistrationView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var RegistrationView = _wrapComponent('RegistrationView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(RegistrationView, _Component);

    function RegistrationView() {
        (0, _classCallCheck3.default)(this, RegistrationView);
        return (0, _possibleConstructorReturn3.default)(this, (RegistrationView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationView)).apply(this, arguments));
    }

    (0, _createClass3.default)(RegistrationView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                changeField = _props.changeField,
                handleOnClick = _props.handleOnClick,
                handleOnEnter = _props.handleOnEnter,
                onHide = _props.onHide,
                preload = _props.preload,
                state = _props.state,
                status = _props.status,
                title = _props.title;


            return _react3.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: true,
                    dialogClassName: 'registration-modal',
                    onHide: onHide
                },
                _react3.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react3.default.createElement(
                        'h4',
                        { className: 'modal-title' },
                        title
                    )
                ),
                _react3.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    _react3.default.createElement(
                        _components2.Preloader,
                        { preload: preload },
                        _react3.default.createElement(_components2.RegistrationFull, {
                            state: state,
                            status: status,
                            changeField: changeField,
                            handleOnClick: handleOnClick,
                            handleOnEnter: handleOnEnter
                        })
                    )
                )
            );
        }
    }]);
    return RegistrationView;
}(_react2.Component), _class.propTypes = {
    changeField: _react2.PropTypes.func.isRequired,
    handleOnClick: _react2.PropTypes.func.isRequired,
    handleOnEnter: _react2.PropTypes.func.isRequired,
    onHide: _react2.PropTypes.func.isRequired,
    preload: _react2.PropTypes.bool.isRequired,
    state: _react2.PropTypes.object.isRequired,
    status: _react2.PropTypes.object.isRequired,
    title: _react2.PropTypes.string.isRequired
}, _temp));

exports.default = RegistrationView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Registration/default/RegistrationView.jsx
// module id = 1843
// module chunks = 0